<script setup lang="ts">
import { computed } from 'vue'
import { T } from '@tolgee/vue'
import { useWatchOverlays } from '@/composables/helpers/scoll'
import { useFullScreenDimensions } from '@/composables/helpers/fullscreen'
import CrossCircleIcon from '@/components/icons/CrossCircleIcon.vue'
import { useHapticFeedback } from '@/composables/game/haptic-feedback'

const props = defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

useWatchOverlays(computed(() => props.show))
const { topStyle } = useFullScreenDimensions()
const { addHapticFeedback } = useHapticFeedback()

function onClose() {
  addHapticFeedback('light')
  emit('close')
}
</script>

<template>
  <Transition
    name="fade"
    mode="out-in"
  >
    <div
      v-if="show"
      class="fixed h-screen max-h-dvh w-screen overflow-hidden left-0 bottom-0 bg-dark-most-bottom-layer/[.95] flex flex-col z-[800]"
      @click="onClose"
    >
      <CrossCircleIcon
        class="w-6 h-6 min-w-[24px] absolute top-3 right-3 text-white/[87%]"
        :style="topStyle"
      />
      <div class="h-full w-full flex-1 flex flex-col gap-y-6 items-center justify-center relative">
        <div
          class="absolute w-[334px] h-[334px] rounded-full bg-teal-primary/[.54] blur-[43px] -z-[1]"
        />
        <h1 class="text-white text-[36px] font-bold leading-[42px] text-center">
          <T
            key-name="daily.all_done.good_luck"
            default-value="Good job!"
          />
        </h1>
        <img
          src="@/assets/images/like.webp"
          class="size-[195px]"
        >
        <div class="text-lg leading-6 text-center font-semibold max-w-[377px] text-white/[.87]">
          <T
            key-name="daily.all_done.text"
            :default-value="`You’ve completed all your goals for today!\n Every step counts — keep building your momentum!`"
          />
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
